import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trash2, CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function RequestDeletePage() {
  const [formData, setFormData] = useState({ case_id: '', name: '', mobile: '', reason: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.case_id || !formData.name || !formData.mobile) {
      setError('कृपया सभी आवश्यक फ़ील्ड भरें');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/delete-request`, formData);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-white pb-24 md:pb-12" data-testid="request-delete-page">
        <div className="max-w-xl mx-auto px-4 py-16 text-center">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h2 className="font-outfit font-bold text-2xl text-gray-900 mb-2">अनुरोध प्राप्त हुआ</h2>
          <p className="text-gray-600 mb-6">आपका लिस्टिंग हटाने का अनुरोध सफलतापूर्वक दर्ज हो गया है। हम 48 घंटे के भीतर कार्रवाई करेंगे।</p>
          <p className="text-gray-500 text-sm mb-6">Your deletion request has been submitted successfully. We will take action within 48 hours.</p>
          <Link to="/"><Button className="rounded-full bg-red-600 hover:bg-red-700">होम पर जाएं</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-24 md:pb-12" data-testid="request-delete-page">
      <div className="max-w-xl mx-auto px-4 py-8 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 mb-6">
          <ArrowLeft className="w-4 h-4" />वापस जाएं
        </Link>
        <div className="flex items-center gap-3 mb-4">
          <Trash2 className="w-8 h-8 text-red-600" />
          <h1 className="font-outfit font-bold text-3xl text-gray-900">लिस्टिंग हटाने का अनुरोध</h1>
        </div>
        <p className="text-gray-600 mb-2">यदि आप चाहते हैं कि आपकी या आपके परिवार के सदस्य की लिस्टिंग इस पोर्टल से हटा दी जाए, तो कृपया नीचे फ़ॉर्म भरें।</p>
        <p className="text-gray-500 text-sm mb-8">If you want your or your family member's listing removed from this portal, please fill the form below.</p>

        {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl mb-4 text-sm" data-testid="delete-error">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">केस नंबर / Case ID <span className="text-red-500">*</span></label>
            <input
              type="text"
              placeholder="जैसे: GUM-3AF6CD"
              value={formData.case_id}
              onChange={(e) => setFormData({...formData, case_id: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none"
              data-testid="delete-case-id"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">आपका नाम / Your Name <span className="text-red-500">*</span></label>
            <input
              type="text"
              placeholder="अपना पूरा नाम दर्ज करें"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none"
              data-testid="delete-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">मोबाइल नंबर / Mobile Number <span className="text-red-500">*</span></label>
            <input
              type="tel"
              placeholder="10 अंकों का मोबाइल नंबर"
              value={formData.mobile}
              onChange={(e) => setFormData({...formData, mobile: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none"
              data-testid="delete-mobile"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">कारण / Reason</label>
            <textarea
              placeholder="लिस्टिंग हटाने का कारण बताएं (वैकल्पिक)"
              value={formData.reason}
              onChange={(e) => setFormData({...formData, reason: e.target.value})}
              rows={3}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none resize-none"
              data-testid="delete-reason"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-xl bg-red-600 hover:bg-red-700 text-white font-medium"
            data-testid="delete-submit-btn"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'अनुरोध भेजें / Submit Request'}
          </Button>
        </form>
      </div>
    </div>
  );
}
